import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { FILE_SCOPE_REQUEST_CHAT } from '../../../constants/file'
import { QA_NAME_SHOW_MORE_BUTTON } from '../../../constants/qa'
import { ButtonArrow } from '../../Button'
import { FileList, FileListDownloadAll, FilePreview } from '../../File'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import { CHATROOM_MESSAGE_FILES_VISIBLE_COUNT } from '../Chatroom.constants'

import { getChatroomMessageFilesVisible } from './ChatroomMessageFiles.utils'

import * as styles from './ChatroomMessageFiles.module.css'

function ChatroomMessageFiles({
  filePreviewProps: { scope = FILE_SCOPE_REQUEST_CHAT, subject } = EMPTY_OBJECT,
  files,
  message,
}) {
  const { t } = useTranslation()

  const [isExpanded, setExpanded] = useState(false)

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files })

  const hasMore = files.length > CHATROOM_MESSAGE_FILES_VISIBLE_COUNT

  const visibleFiles = getChatroomMessageFilesVisible({ files, isExpanded })

  function handleToggleExpanded() {
    setExpanded(value => !value)
  }

  function renderFile(file, key) {
    return (
      <FilePreview
        allowRemove={false}
        file={file}
        key={key}
        onClick={handleClickFile}
      />
    )
  }

  return (
    <div className={styles.chatroomMessageFiles}>
      {message?.permissions?.can_download_files ? (
        <FileListDownloadAll className={styles.filesHeader} files={files} />
      ) : null}
      <FileList
        className={styles.filesList}
        files={visibleFiles}
        itemClassName={styles.filesListItem}
        renderItem={renderFile}
      />
      {hasMore ? (
        <ButtonArrow
          isGreySecondary
          className={styles.toggle}
          isOpen={isExpanded}
          qaName={QA_NAME_SHOW_MORE_BUTTON}
          text={t(
            isExpanded
              ? 'Chatroom.MessageFilesShowLessKey'
              : 'Chatroom.MessageFilesShowMoreKey'
          )}
          onClick={handleToggleExpanded}
        />
      ) : null}
      <FilesPreviewGallery
        files={files}
        initActive={activeFileIndex}
        scope={scope}
        subject={subject}
        onClose={handleCloseFilePreview}
      />
    </div>
  )
}

export default ChatroomMessageFiles
